// @flow
import React from 'react';
import { css } from 'emotion';
import { colors, fonts } from '@peachjar/components';

import ProgressBar from './ProgressBar';
import CancelIcon from './CancelIcon.svg';
import Checkmark from './Checkmark.svg';
import CsvIcon from './CsvIcon.svg';

const { ProximaNova } = fonts;
const { dragon, prussian } = colors;

type LineValidationError = {
  lineNumber: number,
  reasons: string[],
}

function RenderIcon(props: Props) {
  if (props.errors.length) return <CancelIcon />;

  if (props.uploadPercentage >= 100) {
    return <Checkmark />;
  }

  return <CancelIcon />;
}

function RenderErrors(props: Props) {
  if (!props.errors.length) return null;

  return props.errors.map((error: LineValidationError) => {
    return (
      <div key={`error-${error.lineNumber}`}>
        <span style={{ color: dragon }}>{
          error.lineNumber === 0 ?
            `Missing Requirements:` :
            `Line: ${error.lineNumber}:`
        }</span>
        {error.reasons.map(errorMessage => (
          <div key={errorMessage}>- {errorMessage}</div>
        ))}
      </div>
    );
  });
}

type Props = {
  filename: string,
  uploadComplete: boolean,
  uploadPercentage: number,
  errors: Array<CSVError>,
};

const UploadStatusBox = (props: Props) => (
  <div>
    <div className={`row ${styles.row}`}>
      <div className="col">
        <div className="row" style={{ height: '46px', width: '38px' }}>
          <CsvIcon />
        </div>
      </div>
      <div className="col-11 d-flex flex-column justify-content-center">
        <div
          className={`row d-flex justify-content-between ${styles.filename}`}
        >
          {props.filename}
          {RenderIcon(props)}
        </div>
        <div className="row" style={{ marginTop: '8px' }}>
          <ProgressBar
            percentage={props.uploadPercentage}
            message={props.errors.length > 0 ? 'error' : 'success'}
          />
          <div className="d-flex flex-column">{RenderErrors(props)}</div>
        </div>
      </div>
    </div>
  </div>
);

const styles = {
  filename: css`
    font-family: ${ProximaNova};
    font-size: 19px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.26;
    letter-spacing: normal;
    color: ${prussian};
  `,
  row: css`
    width: 920px;
    min-height: 56px;
    padding: 16px 19px;
    margin-bottom: 16px;
    border: 1px solid #e6e6e6;
    border-radius: 3px;
    margin-left: 0 !important;
  `,
};

export default UploadStatusBox;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/components/UploadStatusBox.jsx